import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { Bars } from "react-loader-spinner";


 import axiosInstance from "../../Shared/axiosInstance";



export default function AddPayment() {
  const { id } = useParams(); // purchaseId
  const [errorMsg, setErrorMsg] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingPurchase, setLoadingPurchase] = useState(true);
  const [purchaseData, setPurchaseData] = useState(null);
  const navigate = useNavigate();







  // ✅ Fetch purchase details on component mount
  useEffect(() => {
    const fetchPurchaseDetails = async () => {
      try {
        setLoadingPurchase(true);
        const { data } = await axiosInstance.get(`/Purchase/get-purchase/${id}`);
        setPurchaseData(data.data);
      } catch (error) {
        console.error("Error fetching purchase details:", error);
        Swal.fire({
          icon: "error",
          title: "خطأ",
          text: "فشل تحميل بيانات المشتريات",
        });
        navigate("/purchases");
      } finally {
        setLoadingPurchase(false);
      }
    };

    fetchPurchaseDetails();
  }, [id]);

  const API = "/Payment/add-payment";

  // ✅ Available payment methods - مترجمة للعربي
  const paymentMethods = [
    { value: "0", label: "💵 نقدي" },
    { value: "1", label: "📱 فودافون كاش" },
    { value: "2", label: "💳 انستا باي" },
  ];

  // ✅ Get payment method name in Arabic
  const getPaymentMethodName = (methodValue) => {
    const method = paymentMethods.find(m => m.value === methodValue);
    return method ? method.label : "-";
  };

  // ✅ Calculate totals
  const totalPaid = purchaseData?.payments?.reduce((sum, p) => sum + p.amount, 0) || 0;
  const remaining = (purchaseData?.totalAmount || 0) - totalPaid;

  // ✅ Formik with Yup validation - مترجمة للعربي
  const formik = useFormik({
    initialValues: {
      amount: "",
      date: new Date().toISOString().split("T")[0],
      method: "",
    },
    validationSchema: Yup.object({
      amount: Yup.number()
        .required("المبلغ مطلوب")
        .positive("المبلغ يجب أن يكون موجب")
        .min(0.01, "المبلغ يجب أن يكون على الأقل 0.01")
        .max(remaining, `المبلغ لا يمكن أن يتجاوز المتبقي (${remaining.toFixed(2)} جنيه)`),
      date: Yup.string().required("التاريخ مطلوب"),
      method: Yup.string().required("طريقة الدفع مطلوبة"),
    }),
    onSubmit: async (values) => {
      setIsLoading(true);
      setErrorMsg(null);
      try {
        const body = {
          purchaseId: id,
          amount: parseFloat(values.amount),
          date: values.date,
          method: parseInt(values.method),
        };

        const { data } = await axiosInstance.post(API, body);

        if (data?.status === 200 || data?.status === "success" || data) {
          await Swal.fire({
            title: "نجح!",
            text: data.message || "تم إضافة الدفعة بنجاح",
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
          });

          navigate("/purchases");
        }
      } catch (error) {
        console.error("Error adding payment:", error);
        const serverMsg = error?.response?.data?.message;
        setErrorMsg(serverMsg || "حدث خطأ ما. يرجى المحاولة مرة أخرى.");
      } finally {
        setIsLoading(false);
      }
    },
  });

  // ✅ Show loading spinner while fetching purchase data
  if (loadingPurchase) {
    return (
      <div style={{ background: "#f8fafc", minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div className="text-center">
          <Bars height="60" width="60" color="#22c55e" ariaLabel="loading" />
          <p style={{ marginTop: "16px", color: "#64748b", fontSize: "16px" }}>جاري تحميل بيانات المشتريات...</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ background: "#f8fafc", minHeight: "100vh", paddingBottom: "40px" }}>
      <div className="container py-5" style={{ maxWidth: "800px" }}>
        
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-4 mt-5 pt-5">
          <div>
            <h2 style={{ color: "#22c55e", fontWeight: "700", fontSize: "28px", marginBottom: "4px" }}>
              <i className="bi bi-cash-coin me-2"></i>إضافة دفعة شراء
            </h2>
            <small style={{ color: "#64748b", fontSize: "14px" }}>
              تسجيل دفعة جديدة للمشتريات #{id}
            </small>
          </div>
          <button
            type="button"
            onClick={() => navigate("/purchases")}
            style={{
              background: "#64748b",
              color: "#fff",
              padding: "10px 20px",
              borderRadius: "6px",
              border: "none",
              fontWeight: "600",
              fontSize: "15px",
              cursor: "pointer",
            }}
          >
            <i className="bi bi-arrow-left me-1"></i> رجوع
          </button>
        </div>

        {/* Purchase Information Card */}
        {purchaseData && (
          <div style={{
            background: "#fff",
            border: "2px solid #93c5fd",
            borderRadius: "12px",
            padding: "24px",
            marginBottom: "24px",
            boxShadow: "0 4px 12px rgba(59, 130, 246, 0.15)",
          }}>
            <h5 style={{ color: "#2563eb", fontWeight: "700", fontSize: "18px", marginBottom: "16px" }}>
              <i className="bi bi-receipt me-2"></i>معلومات المشتريات
            </h5>
            
            <div className="row mb-3">
              <div className="col-md-6">
                <div style={{ color: "#64748b", fontSize: "13px", marginBottom: "4px" }}>المورد</div>
                <div style={{ color: "#1e293b", fontSize: "16px", fontWeight: "600" }}>
                  {purchaseData.supplierName}
                </div>
              </div>
              <div className="col-md-6">
                <div style={{ color: "#64748b", fontSize: "13px", marginBottom: "4px" }}>تاريخ الشراء</div>
                <div style={{ color: "#1e293b", fontSize: "16px", fontWeight: "600" }}>
                  {new Date(purchaseData.purchaseDate).toLocaleDateString()}
                </div>
              </div>
            </div>

            <div style={{
              background: "#f8fafc",
              borderRadius: "8px",
              padding: "16px",
              border: "1px solid #e2e8f0",
            }}>
              <div className="row mb-2">
                <div className="col-6">
                  <span style={{ color: "#64748b", fontSize: "15px" }}>إجمالي المبلغ:</span>
                </div>
                <div className="col-6 text-end">
                  <span style={{ color: "#1e40af", fontSize: "18px", fontWeight: "700" }}>
                    {purchaseData.totalAmount.toLocaleString()} جنيه
                  </span>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-6">
                  <span style={{ color: "#64748b", fontSize: "15px" }}>المدفوع:</span>
                </div>
                <div className="col-6 text-end">
                  <span style={{ color: "#16a34a", fontSize: "18px", fontWeight: "700" }}>
                    {totalPaid.toLocaleString()} جنيه
                  </span>
                </div>
              </div>

              <div className="row" style={{ 
                borderTop: "2px solid #cbd5e1", 
                paddingTop: "12px", 
                marginTop: "8px" 
              }}>
                <div className="col-6">
                  <span style={{ color: "#64748b", fontSize: "16px", fontWeight: "600" }}>
                    المتبقي:
                  </span>
                </div>
                <div className="col-6 text-end">
                  <span style={{ 
                    color: remaining > 0 ? "#dc2626" : "#16a34a", 
                    fontSize: "22px", 
                    fontWeight: "700" 
                  }}>
                    {remaining.toLocaleString()} جنيه
                  </span>
                </div>
              </div>
            </div>

            {/* Previous Payments */}
            {purchaseData.payments && purchaseData.payments.length > 0 && (
              <div style={{ marginTop: "20px" }}>
                <h6 style={{ color: "#475569", fontSize: "15px", fontWeight: "600", marginBottom: "12px" }}>
                  <i className="bi bi-clock-history me-2"></i>الدفعات السابقة ({purchaseData.payments.length})
                </h6>
                <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                  {purchaseData.payments.map((payment, index) => (
                    <div key={index} style={{
                      background: "#f8fafc",
                      border: "1px solid #e2e8f0",
                      borderRadius: "6px",
                      padding: "12px",
                      marginBottom: "8px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}>
                      <div>
                        <div style={{ color: "#1e293b", fontSize: "15px", fontWeight: "600" }}>
                          {payment.amount.toLocaleString()} جنيه
                        </div>
                        <div style={{ color: "#64748b", fontSize: "13px" }}>
                          {new Date(payment.date).toLocaleDateString()} • {getPaymentMethodName(payment.method.toString())}
                        </div>
                      </div>
                      <div style={{
                        background: "#dcfce7",
                        color: "#16a34a",
                        padding: "4px 12px",
                        borderRadius: "4px",
                        fontSize: "12px",
                        fontWeight: "600",
                      }}>
                        مدفوع
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}

        {/* Error Message */}
        {errorMsg && (
          <div style={{
            background: "#fee2e2",
            border: "1px solid #fecaca",
            color: "#991b1b",
            padding: "12px 16px",
            borderRadius: "8px",
            marginBottom: "20px",
            fontSize: "14px",
            fontWeight: "600",
          }}>
            <i className="bi bi-exclamation-triangle me-2"></i>
            {errorMsg}
          </div>
        )}

        {/* Form Card */}
        <div style={cardStyle}>
          <h5 style={{ color: "#1e293b", fontWeight: "700", fontSize: "18px", marginBottom: "20px" }}>
            <i className="bi bi-plus-circle me-2"></i>تفاصيل الدفعة الجديدة
          </h5>

          <form onSubmit={formik.handleSubmit}>
            
            {/* Amount */}
            <div className="mb-4">
              <label style={labelStyle}>
                <i className="bi bi-currency-dollar me-2"></i>مبلغ الدفعة (جنيه)
              </label>
              <input
                type="number"
                name="amount"
                placeholder={`أدخل المبلغ (الحد الأقصى: ${remaining.toFixed(2)} جنيه)`}
                step="0.01"
                min="0"
                max={remaining}
                value={formik.values.amount}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                onWheel={(e) => e.target.blur()}
                style={{
                  ...inputStyle,
                  borderColor: formik.touched.amount && formik.errors.amount ? "#dc2626" : "#cbd5e1",
                }}
              />
              {formik.touched.amount && formik.errors.amount && (
                <div style={errorStyle}>
                  <i className="bi bi-exclamation-circle me-1"></i>
                  {formik.errors.amount}
                </div>
              )}
            </div>

            {/* Date */}
            <div className="mb-4">
              <label style={labelStyle}>
                <i className="bi bi-calendar-event me-2"></i>تاريخ الدفع
              </label>
              <input
                type="date"
                name="date"
                value={formik.values.date}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                style={{
                  ...inputStyle,
                  borderColor: formik.touched.date && formik.errors.date ? "#dc2626" : "#cbd5e1",
                }}
              />
              {formik.touched.date && formik.errors.date && (
                <div style={errorStyle}>
                  <i className="bi bi-exclamation-circle me-1"></i>
                  {formik.errors.date}
                </div>
              )}
            </div>

            {/* Payment Method */}
            <div className="mb-4">
              <label style={labelStyle}>
                <i className="bi bi-credit-card me-2"></i>طريقة الدفع
              </label>
              <select
                name="method"
                value={formik.values.method}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                style={{
                  ...inputStyle,
                  borderColor: formik.touched.method && formik.errors.method ? "#dc2626" : "#cbd5e1",
                }}
              >
                <option value="">-- اختر طريقة الدفع --</option>
                {paymentMethods.map((m) => (
                  <option key={m.value} value={m.value}>
                    {m.label}
                  </option>
                ))}
              </select>
              {formik.touched.method && formik.errors.method && (
                <div style={errorStyle}>
                  <i className="bi bi-exclamation-circle me-1"></i>
                  {formik.errors.method}
                </div>
              )}
            </div>

            {/* Summary Box */}
            {formik.values.amount && formik.values.method !== "" && (
              <div style={{
                background: "#f0fdf4",
                border: "2px solid #86efac",
                borderRadius: "8px",
                padding: "16px",
                marginBottom: "20px",
              }}>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span style={{ color: "#166534", fontWeight: "600", fontSize: "14px" }}>
                    مبلغ الدفع:
                  </span>
                  <span style={{ color: "#166534", fontWeight: "700", fontSize: "20px" }}>
                    {parseFloat(formik.values.amount || 0).toFixed(2)} جنيه
                  </span>
                </div>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span style={{ color: "#166534", fontWeight: "600", fontSize: "14px" }}>
                    الطريقة:
                  </span>
                  <span style={{ color: "#166534", fontWeight: "600", fontSize: "15px" }}>
                    {paymentMethods.find(m => m.value === formik.values.method)?.label || "-"}
                  </span>
                </div>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span style={{ color: "#166534", fontWeight: "600", fontSize: "14px" }}>
                    التاريخ:
                  </span>
                  <span style={{ color: "#166534", fontWeight: "600", fontSize: "15px" }}>
                    {new Date(formik.values.date).toLocaleDateString()}
                  </span>
                </div>
                <div style={{ borderTop: "1px solid #86efac", paddingTop: "8px", marginTop: "8px" }}>
                  <div className="d-flex justify-content-between align-items-center">
                    <span style={{ color: "#166534", fontWeight: "600", fontSize: "14px" }}>
                      المتبقي بعد الدفع:
                    </span>
                    <span style={{ color: "#166534", fontWeight: "700", fontSize: "18px" }}>
                      {(remaining - parseFloat(formik.values.amount || 0)).toFixed(2)} جنيه
                    </span>
                  </div>
                </div>
              </div>
            )}

            {/* Submit Button */}
            <button
              type="submit"
              disabled={!(formik.dirty && formik.isValid) || isLoading || remaining <= 0}
              style={{
                width: "100%",
                background: formik.dirty && formik.isValid && !isLoading && remaining > 0
                  ? "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)"
                  : "#94a3b8",
                color: "#fff",
                padding: "16px",
                borderRadius: "8px",
                border: "none",
                fontWeight: "700",
                fontSize: "18px",
                cursor: formik.dirty && formik.isValid && !isLoading && remaining > 0 ? "pointer" : "not-allowed",
                boxShadow: formik.dirty && formik.isValid && !isLoading && remaining > 0
                  ? "0 4px 12px rgba(34, 197, 94, 0.3)"
                  : "none",
                transition: "all 0.3s ease",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
              }}
            >
              {isLoading ? (
                <>
                  <Bars height="25" width="25" color="#fff" ariaLabel="loading" />
                  <span>جاري المعالجة...</span>
                </>
              ) : remaining <= 0 ? (
                <>
                  <i className="bi bi-check-circle-fill"></i>
                  <span>مدفوع بالكامل</span>
                </>
              ) : (
                <>
                  <i className="bi bi-check-circle"></i>
                  <span>إضافة دفعة</span>
                </>
              )}
            </button>
          </form>
        </div>

        {/* Info Card */}
        <div style={{
          background: "#fff",
          border: "1px solid #dbeafe",
          borderRadius: "8px",
          padding: "16px",
          marginTop: "20px",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
        }}>
          <div className="d-flex align-items-start gap-3">
            <div style={{
              background: "#dbeafe",
              color: "#1e40af",
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "20px",
              flexShrink: 0,
            }}>
              <i className="bi bi-info-circle"></i>
            </div>
            <div>
              <h6 style={{ color: "#1e40af", fontWeight: "600", fontSize: "15px", marginBottom: "6px" }}>
                معلومات الدفع
              </h6>
              <p style={{ color: "#64748b", fontSize: "13px", margin: 0, lineHeight: "1.6" }}>
                سيتم تسجيل هذه الدفعة للمشتريات. المبلغ لا يمكن أن يتجاوز الرصيد المتبقي. تأكد من صحة المبلغ وطريقة الدفع قبل الإرسال.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ✅ Styles
const cardStyle = {
  background: "#fff",
  border: "1px solid #e2e8f0",
  borderRadius: "12px",
  padding: "32px",
  marginBottom: "20px",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
};

const labelStyle = {
  color: "#475569",
  fontSize: "15px",
  fontWeight: "600",
  marginBottom: "8px",
  display: "block",
};

const inputStyle = {
  width: "100%",
  padding: "12px 16px",
  border: "2px solid #cbd5e1",
  borderRadius: "8px",
  fontSize: "15px",
  color: "#1e293b",
  outline: "none",
  transition: "all 0.2s",
  fontWeight: "500",
};

const errorStyle = {
  color: "#dc2626",
  fontSize: "13px",
  marginTop: "6px",
  fontWeight: "600",
};